import moment from 'moment';
import { COLUMN_DEFINITIONS } from 'bundles/leads/index/table/cell';

const decamelize = str => str.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');

// Maps client-side filter/sort/page state to server-side query params for
// /projects/:id/project_leads.json. The api helper snake_cases keys before
// sending, so we use camelCase here for readability.
//
// Server endpoints already understood by ProjectLeadSearch.call (via the
// controller): leadSearchText, leadStatus, leadReferralSource, waitListStatus,
// profileUserType, company, listing, caStatus, createdAtStart, createdAtEnd,
// page, perPage, sortBy, sortOrder.
export default function buildLeadsQueryParams({ filters = {}, sort, page, perPage } = {}) {
  const params = {};

  if (page) params.page = page;
  if (perPage) params.perPage = perPage;

  if (sort?.field) {
    const sortValue = COLUMN_DEFINITIONS[sort.field]?.sortValue;
    if (sortValue) {
      // ProjectLeadSearch / Elasticsearch expect snake_case field names. The api helper
      // snake_cases param *keys* but leaves *values* alone, so convert the sort value here.
      params.sortBy = decamelize(sortValue);
      params.sortOrder = sort.reverse ? 'desc' : 'asc';
    }
  }

  if (filters.searchText) params.leadSearchText = filters.searchText;
  if (filters.statusFilter?.length) params.leadStatus = filters.statusFilter;
  if (filters.referralSourceFilter?.length) params.leadReferralSource = filters.referralSourceFilter;
  if (filters.waitlistFilter?.length) params.waitListStatus = filters.waitlistFilter;
  if (filters.profileUserTypeFilter?.length) params.profileUserType = filters.profileUserTypeFilter;
  if (filters.companyFilter?.length) params.company = filters.companyFilter;
  if (filters.listingFilter?.length) params.listing = filters.listingFilter;

  // caStatusFilter is an array of "true"/"false" strings. Both selected = no filter.
  if (filters.caStatusFilter?.length === 1) {
    params.caStatus = filters.caStatusFilter[0] === 'true' ? 'signed_ca' : 'no_ca';
  }

  if (filters.startDate) params.createdAtStart = moment(filters.startDate).toISOString();
  if (filters.endDate) params.createdAtEnd = moment(filters.endDate).toISOString();

  return params;
}
